// src/components/TabNavigation.jsx
import React from "react";

const TabNavigation = ({ activeTab, onTabChange }) => {
  const tabStyle = (isActive) => ({
    flex: 1,
    padding: "12px 20px",
    border: "none",
    borderRadius: "6px",
    background: isActive ? "#4a90e2" : "transparent",
    color: isActive ? "white" : "#666",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s",
    fontSize: "14px",
  });

  return (
    <div
      style={{
        background: "white",
        borderRadius: "8px",
        padding: "6px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        marginBottom: "30px",
        display: "flex",
        gap: "4px",
      }}
    >
      <button
        onClick={() => onTabChange("video")}
        style={tabStyle(activeTab === "video")}
      >
        📹 Video Detection
      </button>
      <button
        onClick={() => onTabChange("image")}
        style={tabStyle(activeTab === "image")}
      >
        📸 Image Analysis
      </button>
    </div>
  );
};

export default TabNavigation;
